import { CircularProgress } from "@mui/material";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

export const MuiTableLoading = ({ columnLength }: { columnLength: number }) => {
  return (
    <TableRow hover role="checkbox" tabIndex={-1}>
      <TableCell
        colSpan={columnLength || 6}
        align="center"
        classes={{
          root: "dark:border-jacarta-100 border-jacarta-100 dark:text-white text-jacarta-700 dark:bg-jacarta-600 bg-jacarta-50",
        }}
      >
        <CircularProgress className="m-5" />
      </TableCell>
    </TableRow>
  );
};
